<template>
<v-row>
    <v-col
        class="flex-grow-0"
    >
        <div
            :style="default_color_block_style"
        >
        </div>
    </v-col>
    <v-col>
        <m-edit-text
            :label="label+' (Default)'"
            :value="default_color"
            read_only
        />
    </v-col>

    <v-col
        class="flex-grow-0"
    >
        <div
            :style="active_color_block_style"
        >
        </div>
    </v-col>
    <v-col>
        <m-edit-text
            :label="label + ' (Active)'"
            :value="value"
            html_color
            hint="Enter a valid HTML color hex code"
            v-on:input="$emit('input',$event)"
            :read_only='read_only'
        />
    </v-col>

</v-row>

</template>

<script>
export default {
    props: {

        default_color: {
            type: String,
            default: function() { return '#000000'; }
        },

        value: {
            type: String,
            default: function() { return '#000000'; }
        },

        label: {
            type: String,
            default: function() { return 'Label Me!'; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    computed: {
        
        default_color_block_style() {
            return 'width: 55px; height: 55px; background-color: '+this.default_color+'; border: 1px solid rgba(0,0,0,0.2);';
        },

        active_color_block_style() {
            return 'width: 55px; height: 55px; background-color: '+this.value+'; border: 1px solid rgba(0,0,0,0.2);';
        }

    },
}
</script>

<style lang="scss" scoped>

</style>